module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "header"
  }, [_vm._t("header", [_c('h4', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('p', {
    staticClass: "category"
  }, [_vm._v(_vm._s(_vm.subTitle))])])], 2), _vm._v(" "), _c('div', {
    staticClass: "content table-responsive table-full-width",
    attrs: {
      "id": "table"
    }
  }, [_c('table', {
    staticClass: "table",
    class: _vm.tableClass,
    attrs: {
      "id": _vm.id
    }
  }, [_c('thead', {
    staticClass: "text-right"
  }, [_c('tr', [(_vm.dayDisplay) ? _c('th', [_vm._v("Dzień")]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("PIT28")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("PIT36")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("PIT36l")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("PIT37")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("PIT38")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("PIT39")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Suma")])])]), _vm._v(" "), _c('tbody', {
    staticClass: "text-center"
  }, [_vm._l((_vm.data), function(item, index) {
    return _c('tr', [(_vm.dayDisplay) ? _c('td', [_vm._v(" " + _vm._s(item.day))]) : _vm._e(), _vm._v(" "), _vm._l((item[_vm.dataType]), function(declarationValue) {
      return _c('td', {
        staticClass: "text-right"
      }, [_vm._v("\n                    " + _vm._s(_vm.dataType == "fills" ? declarationValue : _vm.numberFormatter(declarationValue)) + "\n                ")])
    }), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.dataType == "fills" ? _vm.sumRows[index] : _vm.numberFormatter(_vm.sumRows[index])) + "\n                ")])], 2)
  }), _vm._v(" "), _c('tr', {
    staticClass: "text-right"
  }, [_c('td', {
    staticClass: "text-center"
  }, [_vm._v("Suma")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dataType == 'fills' ? _vm.sum.pit28 : _vm.numberFormatter(_vm.sum.pit28)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dataType == 'fills' ? _vm.sum.pit36 : _vm.numberFormatter(_vm.sum.pit36)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dataType == 'fills' ? _vm.sum.pit36l : _vm.numberFormatter(_vm.sum.pit36l)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dataType == 'fills' ? _vm.sum.pit37 : _vm.numberFormatter(_vm.sum.pit37)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dataType == 'fills' ? _vm.sum.pit38 : _vm.numberFormatter(_vm.sum.pit38)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dataType == 'fills' ? _vm.sum.pit39 : _vm.numberFormatter(_vm.sum.pit39)))]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm.dataType == 'fills' ? _vm.sum.summary : _vm.numberFormatter(_vm.sum.summary)) + "\n                ")])])], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3b5d9a7c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UIComponents/DeclarationsTable.vue
// module id = 477
// module chunks = 1